import { Base } from "./Base";
import { debounce } from "../../utilities/functions";

import Flicking from "@egjs/flicking";
import { EVENTS } from "@egjs/flicking";
import { Pagination } from "@egjs/flicking-plugins";

import "@egjs/flicking-plugins/dist/pagination.css";

const body = document.body;

export class ShopLooks extends Base {
  constructor(behaviorName, element) {
    super(behaviorName, element);
    this.id = null;
    this.total = null;
    this.visible = null;
    this.init();
  }

  init() {
    //
    const { products } = this.refs;
    body.style.setProperty(
      "--shop-looks-product-background-color",
      products.getAttribute("data-product-background-color")
    );

    body.style.setProperty(
      "--shop-looks-ornament-color",
      products.getAttribute("data-ornament-color")
    );
    //
    const { carousel } = this.refs;
    if (carousel) {
      const total = carousel.getAttribute("data-total");

      body.style.setProperty(
        "--shop-looks-product-bullet-color",
        carousel.getAttribute("data-bullet-color")
      );
      this.id = carousel.getAttribute("data-id");
      this.initCarousel(this.id, total);
      this.resizeHandler = debounce(() => {
        this.update();
      }, 250);

      window.addEventListener("resize", this.resizeHandler);
    }
  }

  cleanup() {
    window.removeEventListener("resize", this.resizeHandler);
  }

  update() {
    const { carousel } = this.refs;
    if (carousel) {
      const total = carousel.getAttribute("data-total");
      if (total > 3) {
        let targetPadding = this.refs["productThree"];
        if (total > 4) {
          targetPadding = this.refs["productFour"];
        }
        if (targetPadding) {
          const targetHeight = targetPadding.offsetHeight;
          const targetImageHeight =
            targetPadding.getElementsByClassName("media")[0].offsetHeight;
          const imageBottomPadding = targetHeight - targetImageHeight;
          //console.log("imageBottomPadding: ", imageBottomPadding);
          body.style.setProperty(
            "--shop-looks-image-padding-bottom",
            imageBottomPadding + "px"
          );
        }
      } else {
        body.style.setProperty("--shop-looks-image-padding-bottom", 0 + "px");
      }
    }
  }

  initCarousel(id, total) {
    if (total > 2) {
      const flicking = new Flicking("#shop-looks-carousel-" + id, {
        align: "prev",
        circular: false,
        bound: true,
        panelsPerView: 2,
      });
      const scope = this;
      flicking.on(EVENTS.CHANGED, (evt) => {
        const selected = evt.index;
        const pagination = document.getElementById(
          "pagination-carousel-" + scope.id
        );
        for (let i = 0; i < pagination.children.length; i++) {
          const child = pagination.children[i];
          child.classList.remove("flicking-pagination-bullet-active");
          if (i === selected) {
            child.classList.add("flicking-pagination-bullet-active");
          }
        }
      });
      flicking.addPlugins(
        new Pagination({
          type: "bullet",
        })
      );
    }
  }
}
